import { ThemedStyleFn } from '~src/hooks/useStyles';

// Kept as a named constant (rather than inlined in the style object below)
// so MyTendersTabs.tsx's header-height ResizeObserver measurement can add
// the exact same margin value back on top of getBoundingClientRect() - see
// the comment next to its usage there for why this can't be measured
// automatically.
export const SUBCONTRACTORS_HEADER_MARGIN_BOTTOM = 24;

export const styleFn: ThemedStyleFn = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '100%',
    position: 'relative',
  },
  messageIcon: {
    fontSize: '30px',
    color: theme.colors.white,
  },
  actionsContainer: {
    display: 'flex',
    position: 'absolute',
    right: '0',
    top: '6px',
    marginRight: '8px',
  },
  questionsButtonContainer: {
    position: 'fixed',
    right: '40px',
    bottom: '40px',
    zIndex: 1000,
  },
  actionsRightButton: {
    marginBottom: 0,
    marginLeft: 2,
  },
  buttonDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    type: 'button',
    cursor: 'pointer',
    marginLeft: 4,
    padding: '2px 10px',
    ':hover': {
      backgroundColor: theme.colors.gray,
      borderRadius: 9,
    },
  },
  messageButton: {
    backgroundColor: '#0a254a',
    minWidth: '50px',
    height: '50px',
    borderRadius: '50px',
  },
  messageIcon: {
    fontSize: '24px',
    color: '#fff',
  },
  iconsHeader: {
    fontSize: '20px',
    color: theme.colors.primary,
    transition: '0.3s',
  },
  // Primary-/Secondary Share Keys: Subcontractors tab header - title +
  // 2 spaced description paragraphs, same visual language as the QA tab's
  // QuestionsAnswerUpperBlock (bold title, grey description). Padding
  // matches QA's own questionsListContainer (QuestionsPageLayoutBlock.tsx)
  // paddingTop/paddingLeft - applied only to this header div, not the
  // table below it.
  subcontractorsHeader: {
    paddingTop: '30px',
    paddingLeft: '20px',
    marginBottom: SUBCONTRACTORS_HEADER_MARGIN_BOTTOM,
    maxWidth: 700,
  },
  subcontractorsHeaderTitle: {
    display: 'block',
    fontSize: 18,
    fontWeight: 800,
    marginBottom: 12,
  },
  subcontractorsHeaderContent: {
    display: 'block',
    color: 'grey',
    marginBottom: 12,
  },
  subcontractorsPageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden',
  },
  subcontractorsTableWrapper: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
});
